import { Box } from "@mui/material";
import React, { useEffect } from "react";
import Sidebar from "../../components/SidebarLayout/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import {
  getChecklistTypeMastersList,
  getDepartmentMasterList,
} from "../../redux/actions/mastersAction";
import QuestionMasterContent from "../../components/Masters/QuestionMaster/QuestionMasterContent";

const QuestionMaster = () => {
  const dispatch = useDispatch();

  const CompanyID = localStorage.getItem("companyID");

  useEffect(() => {
    dispatch(
      getChecklistTypeMastersList({
        limit: "",
        offset: "",
      })
    );
    dispatch(
      getDepartmentMasterList({
        companyId: CompanyID,
      })
    );
  }, []);

  return (
    <>
      <Sidebar activeTab="Masters" title="Masters">
        <Box className="globalContainer_For_Content">
          <QuestionMasterContent />
        </Box>
      </Sidebar>
    </>
  );
};

export default QuestionMaster;
